<template>
  <Page>
    <SidePageColumn side="left">
      <QuickSideLinks :quick_links="quick_links"></QuickSideLinks>
      <v-divider class="mt-4"></v-divider>
      <FeaturedSidePromotions
        :page="page"
        section="left"
      ></FeaturedSidePromotions>
    </SidePageColumn>

    <CenterPageColumn :has_nav_bar="true">
      <CenterNavbar
        :crumps="[]"
        title="Promotions"
        :width_class="page_info.center_width_class"
      ></CenterNavbar>

      <div class="componet-has-nav-bar white pt-10" id="promotions_page_top">
        &nbsp;
      </div>

      <div v-if="featured_promotions_count > 0">
        <CardedSectionHeader
          icon="mdi-group"
          label="Featured Promotions"
          id="promotions_page_featured_promotions_section"
        >
        </CardedSectionHeader>
        <div class="white pt-5" style="min-height: 100px">
          <v-row no-gutters>
            <v-col
              cols="12"
              class="pa-2"
              v-for="(promotion, index) in featured_promotions"
              :key="index"
            >
              <PromotionHeader
                :is_loading="is_loading"
                :promotion="promotion"
                :is_owner_view="false"
                :is_in_admin_view="false"
                :is_in_public_view="true"
                cmp_class="d-flex justify-space-between elevation-2 text-left"
              ></PromotionHeader>
            </v-col>
            <v-col cols="12" class="text-center">
              <v-btn
                rounded
                outlined
                color="success"
                :disabled="is_loading"
                class="mt-5 mb-5"
                to="/promotions/group/featured"
              >
                View all
                {{ comma(featured_promotions_count) }}
                Featured Promotions
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </div>

      <div v-if="most_viewed_promotions_count > 0">
        <CardedSectionHeader
          icon="mdi-group"
          label="Most Viewed Promotions"
          id="promotions_page_most_viewed_promotions_section"
        ></CardedSectionHeader>
        <div class="white pt-5" style="min-height: 100px">
          <v-row no-gutters>
            <v-col
              cols="12"
              class="pa-2"
              v-for="(promotion, index) in most_viewed_promotions"
              :key="index"
            >
              <PromotionHeader
                :is_loading="is_loading"
                :promotion="promotion"
                :is_owner_view="false"
                :is_in_admin_view="false"
                :is_in_public_view="true"
                cmp_class="d-flex justify-space-between elevation-2 text-left"
              ></PromotionHeader>
            </v-col>
            <v-col cols="12" class="text-center">
              <v-btn
                rounded
                outlined
                color="success"
                :disabled="is_loading"
                class="mt-5 mb-5"
                to="/promotions/group/most_viewed"
              >
                View top
                {{ comma(page_info.promotions_most_viewed_min_value) }}
                Most Viewed Promotions
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </div>

      <div v-if="on_going_promotions_count > 0">
        <CardedSectionHeader
          icon="mdi-group"
          label="On Going Promotions"
          id="promotions_page_on_going_promotions_section"
        ></CardedSectionHeader>
        <div class="white pt-5" style="min-height: 100px">
          <v-row no-gutters>
            <v-col
              cols="12"
              class="pa-2"
              v-for="(promotion, index) in on_going_promotions"
              :key="index"
            >
              <PromotionHeader
                :is_loading="is_loading"
                :promotion="promotion"
                :is_owner_view="false"
                :is_in_admin_view="false"
                :is_in_public_view="true"
                cmp_class="d-flex justify-space-between elevation-2 text-left"
              ></PromotionHeader>
            </v-col>
            <v-col cols="12" class="text-center">
              <v-btn
                rounded
                outlined
                color="success"
                :disabled="is_loading"
                class="mt-5 mb-5"
                to="/promotions/group/on_going"
              >
                View 
                {{ comma(on_going_promotions_count) }}
                On Going Promotions
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </div>

      <div v-if="overdue_promotions_count > 0">
        <CardedSectionHeader
        icon="mdi-group"
        label="Overdue Promotions"
        id="promotions_page_overdue_promotions_section"
      ></CardedSectionHeader>
        <div class="white pt-5" style="min-height: 100px">
          <v-row no-gutters>
            <v-col
              cols="12"
              class="pa-2"
              v-for="(promotion, index) in overdue_promotions"
              :key="index"
            >
              <PromotionHeader
                :is_loading="is_loading"
                :promotion="promotion"
                :is_owner_view="false"
                :is_in_admin_view="false"
                :is_in_public_view="true"
                cmp_class="d-flex justify-space-between elevation-2 text-left"
              ></PromotionHeader>
            </v-col>
            <v-col cols="12" class="text-center">
              <v-btn
                rounded
                outlined
                color="success"
                :disabled="is_loading"
                class="mt-5 mb-5"
                to="/promotions/group/overdue"
              >
                View 
                {{ comma(overdue_promotions_count) }}
                Overdue Promotions
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </div>

      <Footer
        :is_loading="is_loading"
        @on-hide-loader="$emit('on-hide-loader')"
        @on-show-loader="$emit('on-show-loader')"
      ></Footer>
    </CenterPageColumn>

    <SidePageColumn side="right">
      <SelfPromoAdd :page="page" section="right"></SelfPromoAdd>
      <HomeSideAdsContainer
        :page="page"
        side="right"
        :number_of_ads="3"
      ></HomeSideAdsContainer>
    </SidePageColumn>
  </Page>
</template>

<script>
import Page from "./../../components/Page";
import SidePageColumn from "./../../components/SidePageColumn";
import FeaturedSidePromotions from "./../../components/FeaturedSidePromotions";
import SelfPromoAdd from "./../../components/SelfPromoAdd";
import HomeSideAdsContainer from "./../../components/HomeSideAdsContainer";
import CenterPageColumn from "./../../components/CenterPageColumn";
import CardedSectionHeader from "./../../components/CardedSectionHeader";
import CenterNavbar from "./../../components/CenterNavbar";
import Footer from "./../../components/CenterFooter";
import QuickSideLinks from "./../../components/QuickSideLinks";
import PromotionHeader from "./../../components/PromotionHeader";

import page_info from "./../../lib/page_info";
import Utils from "./../../lib/Utils";
import ServerClient from "./../../lib/ServerClient";
export default {
  name: "Promotions",
  components: {
    Page,
    SidePageColumn,
    FeaturedSidePromotions,
    SelfPromoAdd,
    HomeSideAdsContainer,
    CenterPageColumn,
    CenterNavbar,
    Footer,
    CardedSectionHeader,
    QuickSideLinks,
    PromotionHeader,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    page: "promotions",
    page_info: page_info,
    quick_links: [],
    featured_promotions_count: 0,
    featured_promotions: [],
    most_viewed_promotions_count: 0,
    most_viewed_promotions: [],
    on_going_promotions: [],
    on_going_promotions_count: 0,
    overdue_promotions: [],
    overdue_promotions_count: 0,
    image_link: require("../../assets/lady_2.png"),
  }),
  methods: {
    set_quick_links() {
      var quick_links = [];
      if (this.featured_promotions_count > 0) {
        quick_links.push({
          text: "Featured Promotions",
          href: "#promotions_page_featured_promotions_section",
        });
      }
      if (this.most_viewed_promotions_count > 0) {
        quick_links.push({
          text: "Most Viewed Promotions",
          href: "#promotions_page_most_viewed_promotions_section",
        });
      }
      if (this.on_going_promotions_count > 0) {
        quick_links.push({
          text: "On Going Promotions",
          href: "#promotions_page_on_going_promotions_section",
        });
      }
      if (this.overdue_promotions_count > 0) {
        quick_links.push({
          text: "Overdue Promotions",
          href: "#promotions_page_overdue_promotions_section",
        });
      }

      this.quick_links = quick_links;
    },
    comma(v) {
      if (v < 10) {
        v = "0" + v.toString();
      }
      return Utils.add_commas(v);
    },
    scroll_to_secton(lmnt_id) {
      try {
        var options = {
          offset: 5,
          duration: 1000,
          easing: "easeInOutCubic",
        };
        this.$vuetify.goTo("#" + lmnt_id, options);
      } catch (error) {
        console.log(
          "Error scrolling to section on directory page ",
          error,
          lmnt_id
        );
      }
    },
    set_promo_expired(promo, php_time_now) {
      promo.expiry = "";
      if (php_time_now < parseFloat(promo.starts_on_timestamp)) {
        promo.expiry = "pending";
      } else if (
        php_time_now >= parseFloat(promo.starts_on_timestamp) &&
        php_time_now <= parseFloat(promo.ends_on_timestamp)
      ) {
        promo.expiry = "live";
      } else if (php_time_now > parseFloat(promo.ends_on_timestamp)) {
        promo.expiry = "expired";
      }
      return promo;
    },
    load_promotions_summaries() {
      var php_time_now = Utils.date_str_to_php_time();
      this.$emit("on-show-loader");
      ServerClient.Promotions.get_promotion_page(
        {
          featured_size: this.page_info.promotions_page_featured_size,
          viewd_size: this.page_info.promotions_page_viwed_size,
          on_going_size: this.page_info.promotions_page_on_going_size,
          overdue_size: this.page_info.promotions_page_on_overdue_size,
          time_now: php_time_now,
          most_viewed_min: this.page_info.promotions_most_viewed_min_value,
        },
        (res) => {
          //console.log("promo page results",  res);
          var indexed_promotions = res.indexed_promotions_req.promotions;
          var php_time_now = parseFloat(Utils.date_str_to_php_time());

          //preprocess featured promotions
          var fpromos = [];
          var promo_ids = [];
          for (
            var index = 0;
            index < res.featured_req.featured_promotions.length;
            index++
          ) {
            var fpromo = res.featured_req.featured_promotions[index];
            var promo_id = parseInt(fpromo.promotion_id);
            if (promo_ids.indexOf(promo_id) < 0) {
              if (indexed_promotions[promo_id]) {
                var promo = indexed_promotions[promo_id][0];
                //expiry
                promo = this.set_promo_expired(promo, php_time_now);
                fpromos.push(promo);
                promo_ids.push(promo_id);
              }
            }
          }
          this.featured_promotions_count = fpromos.length;
          //truncate promotions to summary view
          this.featured_promotions = fpromos.splice(
            0,
            this.page_info.promotions_page_featured_size
          );

          //most viewd promotions
          var mv_promos = [];
          var mv_promo_ids = [];
          for (
            var index = 0;
            index < res.most_viewed_req.promotions.length;
            index++
          ) {
            var mv_promo = res.most_viewed_req.promotions[index];
            //console.log("@", index, "id: ", mv_promo.id, "ids:", mv_promo_ids);
            var promo_id = parseInt(mv_promo.id);
            if (mv_promo_ids.indexOf(promo_id) < 0) {
              if (indexed_promotions[promo_id]) {
                var promo = indexed_promotions[promo_id][0];
                //expiry
                mv_promo = this.set_promo_expired(promo, php_time_now);
                mv_promo_ids.push(promo_id);
                mv_promos.push(mv_promo);
              }
            }
          }
          this.most_viewed_promotions_count = mv_promos.length;
          this.most_viewed_promotions = mv_promos.splice(
            0,
            this.page_info.promotions_page_viwed_size
          );
          //console.log("promo page results", mv_promos, res.most_viewed_req.promotions);

          //on going promotions
          var og_promos = [];
          var og_promo_ids = [];
          for (
            var index = 0;
            index < res.on_going_req.promotions.length;
            index++
          ) {
            var og_promo = res.on_going_req.promotions[index];
            //console.log("@", index, "id: ", mv_promo.id, "ids:", mv_promo_ids);
            var promo_id = parseInt(og_promo.id);
            if (og_promo_ids.indexOf(promo_id) < 0) {
              if (indexed_promotions[promo_id]) {
                var promo = indexed_promotions[promo_id][0];
                //expiry
                promo = this.set_promo_expired(promo, php_time_now);
                og_promo_ids.push(promo_id);
                og_promos.push(promo);
              }
            }
          }
          //console.log("Based on true story ", res.on_going_count_req.promotions[0].count);
          this.on_going_promotions_count =
            res.on_going_count_req.promotions[0].count;
          this.on_going_promotions = og_promos.splice(
            0,
            this.page_info.promotions_page_on_going_size
          );

          
          //ovaerdue promotions
          var ov_promos = [];
          var ov_promo_ids = [];
          for (
            var index = 0;
            index < res.over_due_req.promotions.length;
            index++
          ) {
            var ov_promo = res.over_due_req.promotions[index];
            var promo_id = parseInt(ov_promo.id);
            if (ov_promo_ids.indexOf(promo_id) < 0) {
              if (indexed_promotions[promo_id]) {
                var promo = indexed_promotions[promo_id][0];
                //expiry
                promo = this.set_promo_expired(promo, php_time_now);
                ov_promo_ids.push(promo_id);
                ov_promos.push(promo);
              }
            }
          }
          this.overdue_promotions_count =
            res.over_due_count_req.promotions[0].count;
          this.overdue_promotions = ov_promos.splice(
            0,
            this.page_info.promotions_page_on_overdue_size
          );

          this.set_quick_links();
          this.$emit("on-hide-loader");
          //scroll to the top
          this.scroll_to_secton("promotions_page_top");
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log("Errors while loading public errors page", errors);
        }
      );
    },
  },
  mounted() {
    this.load_promotions_summaries();
  },
};
</script>